module.exports = {"510129001":"晋原街道","510129101":"王泗镇","510129103":"新场镇","510129104":"悦来镇","510129105":"安仁镇","510129106":"出江镇","510129107":"花水湾镇","510129108":"西岭镇","510129109":"斜源镇","510129110":"董场镇","510129111":"韩场镇","510129112":"三岔镇","510129113":"上安镇","510129114":"苏家镇","510129115":"青霞镇","510129116":"沙渠镇","510129118":"蔡场镇","510129202":"雾山乡","510129203":"金星乡","510129205":"鹤鸣乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510129.json
// module id = 2267
// module chunks = 0